<template>
    <q-tab
      @click="changeLanguage"
    >
      {{ label }}
    </q-tab>
</template>
<script>
let languages = {
  hileadzz: [
    {
      label: 'English',
      value: 'en'
    },
    {
      label: 'Deutsch',
      value: 'de'
    }
  ],
  talents: [
    {
      label: 'English',
      value: 'en-tal'
    },
    {
      label: 'Deutsch',
      value: 'de-tal'
    }
  ],
}
export default {
  data() {
    return {
      otherLanguage: {
        label: undefined,
        value: undefined
      }
    }
  },
  computed: {
    label() {
      return this.$t('ui.menu.change-language')
    },
    currentLanguage() {
      return this.$store.getters.getCurrentLanguage
    },
    planIsTalents() {
      return this.$store.getters.getCurrentPlanIsTalent
    },
    languages() {
      if (!this.planIsTalents) {
        return languages.hileadzz
      } else {
        return languages.talents
      }
    }
  },
  mounted() {
    this.calculateOtherLanguage()
  },
  methods:{
    changeLanguage(){
      let language = this.otherLanguage.value
      this.$store.commit('CHANGE_LANGUAGE', language)
    },
    calculateOtherLanguage() {
      this.otherLanguage = this.languages.find(o => o.value !== this.currentLanguage)
    }
  },
  watch: {
    planIsTalents() {
      this.calculateOtherLanguage()
    },
    currentLanguage() {
      this.calculateOtherLanguage()
    }
  }
}
</script>



// WEBPACK FOOTER //
// LanguageSwitcher.vue?7f7940d6